import React, { useState } from 'react';
import UniversalIconBtn from '../../../shared/component/headless/button/UniversalIconBtn';
import styled from 'styled-components';
import { useModalStore } from '../../../shared/store/portal/modalStore';
import HeadlessBtn from '../../../shared/component/headless/button/HeadlessBtn';
import { BlackFullWidthBtn } from '../../../shared/component/headless/button/BtnBody';
import { useWorkListStore } from '../../../shared/store/WorkListStore';
import FilterStationProdYear from '../FilterStationProdYear';
import { WorkFilterData } from '../../../shared/dto/EntityRepository';
import belowIcon from '../../../asset/icon/below.png';
import { getModalMessage } from '../../../shared/constants/modalMessages';
import { getBtnName } from '../../../shared/constants/btnNames';
import { useWorkTagStore } from '../../../shared/store/workTagStore';
import FilterStationMemberCredit from '../FilterStationMemberCredit';

const FilterStationModalMobile: React.FC = () => {
  const { clearModal } = useModalStore();
  const filterData = useWorkListStore((s) => s.filterData);
  const setFilterData = useWorkListStore((s) => s.setFilterData);
  const selectedTags = useWorkTagStore((s) => s.selectedTags);
  const [currentFilter, setCurrentFilter] = useState<WorkFilterData>(filterData);

  if (!filterData) return null;

  const handleSubmit = () => {
    setFilterData({
      ...currentFilter,
      tagIds: selectedTags.map((t) => t.id),
    });
    clearModal(400);
  }

  const handleClose = () => {
    clearModal(400);
  }

  return (
    <FilterStationComp>
      <TitleWrapper>
        <FilterStationTitle>{getModalMessage('FILTER_STATION_TITLE')}</FilterStationTitle>
        <UniversalIconBtn
          size="fit"
          border={false}
          isTransparent
          backgroundImg={belowIcon}
          onClick={handleClose}
        />
      </TitleWrapper>
      <FilterContent>
        <FilterStationMemberCredit
          currentFilter={currentFilter}
          setCurrentFilter={setCurrentFilter}
        />
        <FilterStationProdYear currentFilter={currentFilter} setCurrentFilter={setCurrentFilter} />
        {/* 모바일에선 WorkType 필터 비활성화 */}
        {/* <FilterStationWorkType currentFilter={currentFilter} setCurrentFilter={setCurrentFilter} /> */}
      </FilterContent>
      <HeadlessBtn
        value={getBtnName('APPLY')}
        handleClick={handleSubmit}
        StyledBtn={ApplyButton}
      />
    </FilterStationComp>
  );
};

const FilterStationComp = styled.div`
  width: 100%;
  height: fit-content;
  display: flex;
  flex-direction: column;
  max-height: 95vh;
`

const TitleWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  color: ${({ theme }) => theme.colors.color_Gray_02};
  margin-top: clamp(12px, 2vh, 30px);
  margin-bottom: clamp(20px, 8vh, 30px);
`;

const FilterStationTitle = styled.h2`
  ${({ theme }) => theme.typography.Body_01_1};
  color: ${({ theme }) => theme.colors.color_Gray_02};
`

const FilterContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  flex: 1;
  padding-bottom: 20px;
`;

const ApplyButton = styled(BlackFullWidthBtn)`
  margin: 20px 0px 15px 0px;
`;

export default FilterStationModalMobile;
